var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "87 56 563 563",
    width: "563pt",
    height: "563pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_LeCihlc3mzeCNuboeAMzRRrXZPMpvPRM"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 56,
    width: 563,
    height: 563
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_LeCihlc3mzeCNuboeAMzRRrXZPMpvPRM)"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 510.943 94.698 C 469.148 70.107 420.458 56 368.5 56 C 213.136 56 87 182.136 87 337.5 L 87 337.5 C 87 492.864 213.136 619 368.5 619 C 523.864 619 650 492.864 650 337.5 C 650 330.946 649.776 324.443 649.334 318 L 601.196 318 C 601.728 324.43 602 330.934 602 337.5 C 602 466.372 497.372 571 368.5 571 C 239.628 571 135 466.372 135 337.5 L 135 337.5 C 135 208.628 239.628 104 368.5 104 C 411.401 104 451.615 115.595 486.177 135.819 L 510.943 94.698 Z ",
    fillRule: "evenodd",
    fill: "rgb(0,129,135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.2cb99b20fc8ac976bdeb2e6c6e0d0e69.svg";
export { ForwardRef as ReactComponent };